﻿import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';
import SEO from '../components/SEO';

export default function NotFound() {
  const { t, lang } = useLanguage();
  const text404 = lang === 'en' ? 'Page not found' : 'გვერდი ვერ მოიძებნა';
  const goHome = lang === 'en' ? 'Go Home' : 'მთავარ გვერდზე დაბრუნება';
  return (
    <main className="contact-main" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', textAlign: 'center', gridTemplateColumns: '1fr' }}>
      <SEO title={t('seo-404-title')} description={t('seo-404-desc')} />
      <h1 className="card-title" style={{ fontSize: 'clamp(4rem, 10vw, 6rem)', marginBottom: '1rem' }}>404</h1>
      <p style={{ fontSize: '1.2rem', marginBottom: '2rem', color: 'var(--text-light)', opacity: 0.8 }}>{text404}</p>
      <Link to="/" className="call-btn" style={{ minWidth: '44px', minHeight: '44px', justifyContent: 'center' }}>
        {goHome}
      </Link>
    </main>
  );
}
